/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgMyGarage24(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={24}
      height={24}
      fill='none'
      viewBox='0 0 24 24'
      {...props}
    >
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M7.234 6.67a.25.25 0 01.237-.17h9.558a.25.25 0 01.238.17v.001L18.71 11H5.79l1.444-4.329zM4.01 11.63a.745.745 0 00-.01.137v6.983c0 .414.336.75.75.75h4a.75.75 0 00.75-.75V17.5H15v1.25c0 .414.336.75.75.75h4a.75.75 0 00.75-.75v-6.982a.737.737 0 00-.044-.272L18.69 6.197A1.75 1.75 0 0017.03 5H7.47a1.75 1.75 0 00-1.66 1.197l-1.767 5.3a.747.747 0 00-.034.133zM16.5 17.5H19v.5h-2.5v-.5zM19 16H5.5v-3.5H19V16zM5.5 17.5H8v.5H5.5v-.5zm2.75-3.25a1 1 0 11-2 0 1 1 0 012 0zm9 1a1 1 0 100-2 1 1 0 000 2z'
      />
    </svg>
  );
}

export default SvgMyGarage24;
